export const getBrandLogoName = (name) =>
  name?.toLowerCase().replace(/\s|\/|\.|'|`|’/g, '_') ?? ''
